import Axios from 'axios';
import { FRONTEND_API } from '../utils/variables';

export async function fetchMessageDesignsApi(country) {
    return Axios.get(`${FRONTEND_API}/messages/${country}`);
}
